import PropTypes from 'prop-types';

const Stack = ({ color, size, ...props }) => (
    <svg viewBox="0 0 16 16" width={size} height={size} {...props}>
        <path
            d="M2 9.4a.6.6 0 0 1 .6.6v2.667a.733.733 0 0 0 .734.733h9.333a.733.733 0 0 0 .733-.733V10a.6.6 0 1 1 1.2 0v2.667a1.933 1.933 0 0 1-1.933 1.933H3.334A1.933 1.933 0 0 1 1.4 12.667V10a.6.6 0 0 1 .6-.6"
            fill={color}
            fillRule="evenodd"
        />
        <path
            d="M11.8 11.2a.6.6 0 0 1-.6.6H4.8a.6.6 0 1 1 0-1.2h6.4a.6.6 0 0 1 .6.6M11.8 8.8a.6.6 0 0 1-.6.6H4.8a.6.6 0 0 1 0-1.2h6.4a.6.6 0 0 1 .6.6"
            fill={color}
            fillRule="evenodd"
        />
    </svg>
);

export default Stack;

Stack.propTypes = {
    color: PropTypes.string.isRequired,
    size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
};
